import config from './config';
import { simBackend } from '../utils/sim-backend';
import { ajax_utils } from './ajax-utils';
import { ajax_fetch } from './frfr-ajax-fetch';
import { apiLib } from './url-lib';
import { json_utils } from './frfr-json-utils';
import { simBackendAdapter } from './sim-backend-adapter';
// import authUtils from './auth-utils';

/*
AJAX adapter
Obezbedjuje da ostatak aplikacije ne zna da li podaci dolaze sa back i ne zahteva nikakve prepravke ostatka aplikacije u slucaju pravog backenda.
Ukoliko je u config fajlu ukljucen simulirani backend onda pozivamo funkcije koje simuliraju backend ako ne onda koristimo prave ajax pozive.
*/



let simulateBackend = false;
if (config.simulateBackend === true) {
  simulateBackend = true;
}


const ajax = {};

ajax.ajaxHeadersConfigurator = {};
ajax.ajaxHeadersConfigurator.headers = {};
ajax.ajaxHeadersConfigurator.setHeader = (key, value) => {
  // default headers for use with ajax requests
  // console.log('setHeader', key, value);
  if (config.simulateBackend) {
    if (typeof value !== 'string') {
      value = '';
    }
    // console.log('setHeader', key, value);
    ajax.ajaxHeadersConfigurator.headers[key] = value;
    // console.log('*** simBackend HEADERS CONFIG CHANGED', ajax.ajaxHeadersConfigurator);
  } else {
    // pravi backend
  }
  // iako je ukljucen simbackend radi externog API-ja ipak moramo da podesimo i pravi backend headere
  // pravi backend
  ajax_fetch.log();
  const CONTENT_TYPE_JSON = ajax_utils.CONTENT_TYPE_JSON; // 'application/json';
  const initial_getmethod_headers_arr = [
    [key, value]
  ];
  const initial_postmethod_headers_arr = [
    [key, value],
    ['Content-Type', CONTENT_TYPE_JSON]
  ];
  ajax_fetch.getmethod_headers_set_arr(initial_getmethod_headers_arr);
  ajax_fetch.postmethod_headers_set_arr(initial_postmethod_headers_arr);
  ajax_fetch.log();
  return true;
};


ajax.init = () => {
  // za sada cem ostaviti za oba slucaja da setuje headere
  let use_true_headers = true;
  if (config.simulateBackend) {
    // use_true_headers = false;
  }
  if (!use_true_headers) {
    // simulirani backend
    // TODO ???
    return true;
  } else {
    // pravi backend
    ajax_fetch.init(); // INIT HEADERS FOR AJAX REQUESTS
    ajax_fetch.log();
    const CONTENT_TYPE_JSON = ajax_utils.CONTENT_TYPE_JSON; // 'application/json';
    const header_token_key = config.TOKEN_HEADER_KEY;
    const test_token = config.initial_token_value; // 'none_token_placeholder';
    const initial_getmethod_headers_arr = [
      [header_token_key, test_token]
    ];
    const initial_postmethod_headers_arr = [
      [header_token_key, test_token],
      ['Content-Type', CONTENT_TYPE_JSON]
    ];
    ajax_fetch.getmethod_headers_set_arr(initial_getmethod_headers_arr);
    ajax_fetch.postmethod_headers_set_arr(initial_postmethod_headers_arr);
    ajax_fetch.log();
    return true;
  }
};


// ---------


ajax.postAuthLogout = async (token, user_id) => {
  const simEndpoint = 'postAuthLogout';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { user_id });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ user_id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postAuthLogout(), data_prepared);
    return response;
  }
};

ajax.postAuthFormLogin = async (entbox) => {
  const simEndpoint = 'postAuthFormLogin';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = {};
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { entbox });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postAuthFormLogin(), data_prepared);
    return response;
  }
};

ajax.getAuthMyUserData = async (token) => {
  const simEndpoint = 'getAuthMyUserData';
  // AUTOLOGIN (provera da li si ulogovan odmah pri startu aplikacije)
  // ignorisemo URL query parametar za ovaj API jer je bitan sam otoken koji saljemo u headeru
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    // console.log('test token for autologin:', token);
    // console.log('heqaders for autologin:', simHeaders);
    let response = await simBackendAdapter(simEndpoint, null, simHeaders);
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getAuthMyUserData());
    return response;
  }
};

ajax.getDevDbWhole = async () => {
  const simEndpoint = 'getDevDbWhole';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders);
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.postmethod_send(apiLib.getDevDbWhole());
    return response;
  }
};

ajax.postAdminDbInitialSeed = async () => {
  const simEndpoint = 'postAdminDbInitialSeed';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders);
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.postmethod_send(apiLib.postAdminDbInitialSeed());
    return response;
  }
};

ajax.postAdminDbDelete = async () => {
  const simEndpoint = 'postAdminDbDelete';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders);
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.postmethod_send(apiLib.postAdminDbDelete());
    return response;
  }
};

ajax.getUserList = async () => {
  const simEndpoint = 'getUserList';
  if (config.simulateBackend) {
    // simulirani backend
    /*
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint,  null, simHeaders);
    */
    // simulirani backend
    let response = simBackend.placholders._return_empty_array(); // PLACEHOLDER RESPONSE
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getUserList());
    return response;
  }
};

ajax.postUserCreate = async (entbox) => {
  const simEndpoint = 'postUserCreate';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { entbox });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postUserCreate(), data_prepared);
    return response;
  }
};

ajax.postUserUpdate = async (entbox, id) => {
  const simEndpoint = 'postUserUpdate';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { entbox, id });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox, id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postUserUpdate(), data_prepared);
    return response;
  }
};


ajax.getComorderList = async () => {
  const simEndpoint = 'getComorderList';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders);
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getComorderList());
    return response;
  }
};
ajax.postComorderCreate = async (entbox) => {
  const simEndpoint = 'postComorderCreate';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { entbox });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorderCreate(), data_prepared);
    return response;
  }
};
ajax.postComorderUpdate = async (entbox, id) => {
  const simEndpoint = 'postComorderUpdate';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { entbox, id });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox, id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorderUpdate(), data_prepared);
    return response;
  }
};
ajax.postComorderUpdateFlagDeleted = async (id) => {
  const simEndpoint = 'postComorderUpdateFlagDeleted';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { id });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorderUpdateFlagDeleted(), data_prepared);
    return response;
  }
};
ajax.postComorderUpdateUndelete = async (id) => {
  const simEndpoint = 'postComorderUpdateUndelete';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorderUpdateUndelete(), data_prepared);
    return response;
  }
};


ajax.getComorditemList = async () => {
  const simEndpoint = 'getComorditemList';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders);
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getComorditemList());
    return response;
  }
};
ajax.postComorditemCreate = async (entbox) => {
  const simEndpoint = 'postComorditemCreate';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { entbox });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorditemCreate(), data_prepared);
    return response;
  }
};
ajax.postComorditemUpdate = async (entbox, id) => {
  const simEndpoint = 'postComorditemUpdate';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { entbox, id });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox, id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorditemUpdate(), data_prepared);
    return response;
  }
};
ajax.postComorditemUpdateFlagDeleted = async (id) => {
  const simEndpoint = 'postComorditemUpdateFlagDeleted';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { id });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorditemUpdateFlagDeleted(), data_prepared);
    return response;
  }
};
ajax.postComorditemUpdateUndelete = async (id) => {
  const simEndpoint = 'postComorditemUpdateUndelete';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorditemUpdateUndelete(), data_prepared);
    return response;
  }
};

ajax.postComorditemUpdateUntake = async (id) => {
  const simEndpoint = 'postComorditemUpdateUntake';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorditemUpdateUntake(), data_prepared);
    return response;
  }
};
//
ajax.postComorditemUpdateAdminUntake = async (id) => {
  const simEndpoint = 'postComorditemUpdateAdminUntake';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ id }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postComorditemUpdateAdminUntake(), data_prepared);
    return response;
  }
};


ajax.getVirbomSingleByParentId = async (virbom_parent_id, is_read_only) => {
  const simEndpoint = 'getVirbomSingleByParentId';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, null, { virbom_parent_id });
    return response;
  } else {
    // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ virbom_parent_id }); // ENCODE...
    let response = await ajax_fetch.getmethod_send(apiLib.getVirbomSingleByParentId(virbom_parent_id, is_read_only));
    return response;
  }
};

ajax.getVirbomRevParticular = async (rev_id) => {
  const simEndpoint = 'getVirbomRevParticular';
  if (config.simulateBackend) {
    // simulirani backend
    // TODO
    /*
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint,  null, simHeaders, null, { virbom_parent_id });
    return response;
    */
  } else {
    // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    return response;
  }
};

ajax.getVirbomListRevs = async () => {
  const simEndpoint = 'getVirbomListRevs';
  if (config.simulateBackend) {
    // simulirani backend
    let response = simBackend.placholders._return_empty_array(); // PLACEHOLDER RESPONSE
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getVirbomListRevs());
    return response;
  }
};

ajax.getVirbomListRevsByParentId = async (virbom_parent_id) => {
  const simEndpoint = 'getVirbomListRevsByParentId';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    // let response = await simBackendAdapter(simEndpoint,  null, simHeaders, null, { virbom_parent_id });
    let response = simBackend.placholders._return_empty_array(); // PLACEHOLDER RESPONSE
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getVirbomListRevsByParentId(virbom_parent_id));
    return response;
  }
};

ajax.postVirbomUpdate = async (xentbox) => {
  const simEndpoint = 'postVirbomUpdate';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { xentbox }); // TODO
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ xentbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postVirbomUpdate(), data_prepared);
    return response;
  }
};

ajax.postVirbomRevUpdatePublished = async (entbox) => {
  const simEndpoint = 'postVirbomRevUpdatePublished';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postVirbomRevUpdatePublished(), data_prepared);
    return response;
  }
};


ajax.getGenusPpList = async () => {
  const simEndpoint = 'getGenusPpList';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders);
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getGenusPpList());
    return response;
  }
};

ajax.postGenusUpdateSmartArr = async (virtel_need_genus_arr) => {
  const simEndpoint = 'postGenusUpdateSmartArr';
  if (config.simulateBackend) {
    // simulirani backend
    let simHeaders = ajax.ajaxHeadersConfigurator.headers;
    let response = await simBackendAdapter(simEndpoint, null, simHeaders, { virtel_need_genus_arr });
    return response;
  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ virtel_need_genus_arr }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postGenusUpdateSmartArr(), data_prepared);
    return response;
  }
};


// --------- ADMIN PANEL APIs

ajax.getLibTerConstsList = async () => {
  const simEndpoint = 'getLibTerConstsList';
  if (config.simulateBackend) {
    // simulirani backend
    let response = simBackend.placholders._return_empty_array(); // PLACEHOLDER RESPONSE
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibTerConstsList());
    return response;
  }
};
ajax.getLibTerConstsListRevsByOfId = async () => {
  const simEndpoint = 'getLibTerConstsListRevsByOfId';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibTerConstsListRevsByOfId());
    return response;
  }
};

ajax.getLibVirtelParamsList = async () => {
  const simEndpoint = 'getLibVirtelParamsList';
  if (config.simulateBackend) {
    // simulirani backend
    let response = simBackend.placholders._return_empty_array(); // PLACEHOLDER RESPONSE
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibVirtelParamsList());
    return response;
  }
};
ajax.getLibVirtelParamsListRevsByOfId = async (of_id) => {
  const simEndpoint = 'getLibVirtelParamsListRevsByOfId';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibVirtelParamsListRevsByOfId(of_id));
    return response;
  }
};

ajax.postLibVirtelParamsCreate = async (entbox) => {
  const simEndpoint = 'postLibVirtelParamsCreate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibVirtelParamsCreate(), data_prepared);
    return response;
  }
};
ajax.postLibVirtelParamsUpdate = async (entbox) => {
  const simEndpoint = 'postLibVirtelParamsUpdate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibVirtelParamsUpdate(), data_prepared);
    return response;
  }
};


ajax.getLibMaterijalLimParamsList = async () => {
  const simEndpoint = 'getLibMaterijalLimParamsList';
  if (config.simulateBackend) {
    // simulirani backend
    let response = simBackend.placholders._return_empty_array(); // PLACEHOLDER RESPONSE
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibMaterijalLimParamsList());
    return response;
  }
};
ajax.getLibMaterijalLimParamsListRevsByOfId = async (of_id) => {
  const simEndpoint = 'getLibMaterijalLimParamsListRevsByOfId';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibMaterijalLimParamsListRevsByOfId(of_id));
    return response;
  }
};
ajax.postLibMaterijalLimParamsCreate = async (entbox) => {
  const simEndpoint = 'postLibMaterijalLimParamsCreate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibMaterijalLimParamsCreate(), data_prepared);
    return response;
  }
};
ajax.postLibMaterijalLimParamsUpdate = async (entbox) => {
  const simEndpoint = 'postLibMaterijalLimParamsUpdate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibMaterijalLimParamsUpdate(), data_prepared);
    return response;
  }
};


ajax.getLibCparamsList = async () => {
  const simEndpoint = 'getLibCparamsList';
  if (config.simulateBackend) {
    // simulirani backend
    let response = simBackend.placholders._return_empty_array(); // PLACEHOLDER RESPONSE
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibCparamsList());
    return response;
  }
};
ajax.getLibCparamsListRevsByOfId = async (of_id) => {
  const simEndpoint = 'getLibCparamsListRevsByOfId';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibCparamsListRevsByOfId(of_id));
    return response;
  }
};
ajax.postLibCparamsCreate = async (entbox) => {
  const simEndpoint = 'postLibCparamsCreate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibCparamsCreate(), data_prepared);
    return response;
  }
};
ajax.postLibCparamsUpdate = async (entbox) => {
  const simEndpoint = 'postLibCparamsUpdate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibCparamsUpdate(), data_prepared);
    return response;
  }
};


ajax.getLibCNCProgramS4TemplateList = async () => {
  const simEndpoint = 'getLibCNCProgramS4TemplateList';
  if (config.simulateBackend) {
    // simulirani backend
    // let response = simBackend.placholders._return_empty_array(); // PLACEHOLDER RESPONSE
    let response = simBackend.placholders._return_lib_document_example_s4_templates1(); // PLACEHOLDER RESPONSE
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibCNCProgramS4TemplateList());
    return response;
  }
};
ajax.getLibCNCProgramS4TemplateListRevsByOfId = async (of_id) => {
  const simEndpoint = 'getLibCNCProgramS4TemplateListRevsByOfId';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibCNCProgramS4TemplateListRevsByOfId(of_id));
    return response;
  }
};
ajax.postLibCNCProgramS4TemplateCreate = async (entbox) => {
  const simEndpoint = 'postLibCNCProgramS4TemplateCreate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibCNCProgramS4TemplateCreate(), data_prepared);
    return response;
  }
};
ajax.postLibCNCProgramS4TemplateUpdate = async (entbox) => {
  const simEndpoint = 'postLibCNCProgramS4TemplateUpdate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibCNCProgramS4TemplateUpdate(), data_prepared);
    return response;
  }
};


ajax.getLibDocumentList = async () => {
  const simEndpoint = 'getLibDocumentList';
  if (config.simulateBackend) {
    // simulirani backend
    // let response = simBackend.placholders._return_empty_array(); // PLACEHOLDER RESPONSE
    let response = simBackend.placholders._return_lib_document_example_ventilatori1(); // PLACEHOLDER RESPONSE
    return response;
  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibDocumentList());
    return response;
  }
};
ajax.getLibDocumentListRevsByOfId = async (of_id) => {
  const simEndpoint = 'getLibDocumentListRevsByOfId';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let response = await ajax_fetch.getmethod_send(apiLib.getLibDocumentListRevsByOfId(of_id));
    return response;
  }
};
ajax.postLibDocumentCreate = async (entbox) => {
  const simEndpoint = 'postLibDocumentCreate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibDocumentCreate(), data_prepared);
    return response;
  }
};
ajax.postLibDocumentUpdate = async (entbox) => {
  const simEndpoint = 'postLibDocumentUpdate';
  if (config.simulateBackend) {
    // simulirani backend

    // TODO

  } else {
    // pravi backend
    let data_prepared = ajax_utils.convert_to_json({ entbox }); // ENCODE...
    let response = await ajax_fetch.postmethod_send(apiLib.postLibDocumentUpdate(), data_prepared);
    return response;
  }
};




// --------- EXTERNAL APIs


ajax.getExternalOrderFiles = async (company_orderkey) => {
  // EXTERNAL CALL
  // pravi external backend
  let response = await ajax_fetch.getmethod_send_special2(apiLib.getExternalOrderFilesByKey(company_orderkey)); // privremeno za probu
  return response;
};
ajax.postExternalSpreadsheetUpload = async (entbox) => {
  // EXTERNAL CALL
  // pravi external backend
  // let response = await ajax_fetch.postmethod_send(apiLib.postExternalSpreadsheetUpload(), entbox);
  let response = await ajax_fetch.postmethod_send_special2(apiLib.postExternalSpreadsheetUpload(), entbox); // privremeno za probu
  return response;
};
ajax.getExternalBomInfoByRevId = async (rev_id) => {
  // EXTERNAL CALL
  // pravi external backend
  let response = await ajax_fetch.getmethod_send_special2(apiLib.getExternalBomInfoByRevId(rev_id)); // privremeno za probu
  return response;
};
ajax.getExternalOrderItemsByKey = async (broj_ordera) => {
  // EXTERNAL CALL
  // pravi external backend
  let response = await ajax_fetch.getmethod_send_special2(apiLib.getExternalOrderItemsByKey(broj_ordera)); // privremeno za probu
  return response;
};
ajax.getExternalOrderItemStatusList = async () => {
  // EXTERNAL CALL
  // pravi external backend
  let response = await ajax_fetch.getmethod_send_special2(apiLib.getExternalOrderItemStatusList()); // privremeno za probu
  return response;
};
ajax.getExternalRadniCenriLokacije = async () => {
  // EXTERNAL CALL
  // pravi external backend
  let response = await ajax_fetch.getmethod_send_special2(apiLib.getExternalRadniCenriLokacije()); // privremeno za probu
  return response;
};
ajax.getExternalRadniCenriByLokacija = async (lokacija_id) => {
  // EXTERNAL CALL
  // pravi external backend
  let response = await ajax_fetch.getmethod_send_special2(apiLib.getExternalRadniCenriByLokacija(lokacija_id)); // privremeno za probu
  return response;
};


export default ajax;
